import { SidePanelType, useSidePanelActions } from "PFApp/stores/side_panels_store";

import { KPIsReviewSidepanelData } from "./kpis_review_sidepanel.types";

export const useKPIsReviewSidepanelActions = () => {
  const { open, close } = useSidePanelActions<KPIsReviewSidepanelData>(SidePanelType.KPIsReview);

  return {
    openKPIsReviewSidepanel: open,
    closeKPIsReviewSidepanel: close
  };
};
